import React from 'react'


export default function Index(props) {
  return (
    <div className="assessment1-container">
      <div className="assessment1-wrap">
        <div className="assessment1-title">
          Directions
        </div>
        <div className="assessment1-content">
          The guests have finished dinner, you've cleared their plates, and three of the guests have decided on beverages for dessert. When the drinks are ready to retrieve, you notice that the kitchen accidentally provided an extra beverage. Instead of bothering the guests by double checking on the order, you remember there was a pattern across the three drinks. You know your restaurant serves coffee, tea, and cider. Beverages come in three sizes (small, medium, large).  And at the guest's desired temperature (cold, room temperature, hot).  With these categories in mind, use your deductive reasoning skills to detect which beverage is the odd one out.
        </div>

        <div onClick={() => props.nextPage()} className="assessment1-start-btn">
          Get started
        </div>
      </div>
    </div>
  )
}
